import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import LockIcon from "@mui/icons-material/Lock";
import { useTheme } from "@mui/material/styles";
import { formatPhoneBR } from "../../../../shared/utils/formatPhoneBR"

export default function Header({ instanceName, sender, status }) {
  const theme = useTheme();

  const isActive = status === "active" || status === "open";

  return (
    <>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: 24,
            color: theme.palette.custom.gray[600],
          }}
        >
          Configurar{" "}
          <Typography
            component="span"
            sx={{
              fontSize: 24,
              fontWeight: 500,
              color: theme.palette.custom.gray[700],
            }}
          >
            {instanceName || "WhatsApp Business"}
          </Typography>
        </Typography>
      </Grid>

      <Grid item xs={8}>
        <TextField
          fullWidth
          disabled
          size="small"
          value={formatPhoneBR(sender)}
          InputProps={{
            endAdornment: (
              <LockIcon sx={{ color: theme.palette.custom.gray[400] }} />
            ),
          }}
        />
      </Grid>

      <Grid item xs={4}>
        <Box
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "6px",

            backgroundColor: isActive
              ? theme.palette.success.light
              : theme.palette.grey[200],

            color: isActive
              ? theme.palette.success.dark
              : theme.palette.text.secondary,
          }}
        >
          {isActive ? "Conectado" : "Desconectado"}
        </Box>
      </Grid>
    </>
  );
}
